var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"holacon_home",attrs:{"id":"init"}},[_c('HomeMenu'),_vm._v(" "),_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"content-wrapper"},[_c('vue-page-transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdaf4c20","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Init.vue
// module id = null
// module chunks = 